import * as React from 'react';
import {
  TextAreaContainer,
  Label,
  TextAreaComponent,
} from './textArea-components';
type Props = {
  label?: string;
  disabled?: boolean;
  placeholder?: string;
  name?: string;
  value?: string;
  onChange?: (e: any) => void;
  register?: any;
  size?: string;
  showDefaultValue?: boolean;
};

export default function TextArea({
  label,
  showDefaultValue,
  disabled,
  placeholder,
  name,
  value,
  onChange,
  register,
  size,
}: Props) {
  const props = {
    disabled: disabled,
    placeholder: placeholder,
    name: name,
    onChange: onChange,
    ref: register,
    size: size,
  };
  return (
    <TextAreaContainer>
      {label && <Label>{label}</Label>}
      {showDefaultValue ? (
        <TextAreaComponent {...props} defaultValue={value} />
      ) : (
        <TextAreaComponent {...props} value={value} />
      )}
    </TextAreaContainer>
  );
}
